import React from "react";
import CategoryComponent from "../../components/HeaderBox";
import "./index.css";
import serviceLifeIcon from "../../../../../assets/new-product-detail-cats/header-icons/prod-deliveries-icon.svg";
import { useTranslation } from "react-i18next";
import formatDate from "../../components/HeaderBox/formatDate";

const ServiceLife39Icon = () => (
  <img src={serviceLifeIcon} alt="Service Life 39 Icon" width={76} height={76} />
);

const ServiceLife39Header = ({
  className,
  leftBoxProps,
  rightBoxProps,
  productId,
  show,
  ...props
}) => {
  const { t } = useTranslation();

  return (
    <CategoryComponent
      show={show}
      className={`service-life-39-category ${className || ""}`}
      leftBoxProps={{
        icon: <ServiceLife39Icon />,
        title: t("SERVICE_LIFE") || "Service life",
        description:
          t("SERVICE_LIFE_DESC") ||
          "Reference Service Life (RSL) States the expected service life of the product (how long it's designed to last) based on standards or manufacturer info. If FU uses a different time period than the official service life, have to also include the official service life as technical info.",
        productId: productId,
        isSystemBoundary: false,
        customTextColor: "white",
        ...leftBoxProps,
      }}
      rightBoxProps={{
        totals: [
          {
            title: t("TOTAL_LIFECYCLE_PHASE"),
            items: [
              {
                subtitle: t("EMISSIONS"),
                subitems: [
                  {
                    value: "xx (tCO₂e)",
                  },
                ],
              },
            ],
            isSwitchable: false,
          },
        ],
        impactTotals: null,
        lastUpdated: t("DD_MM_YYYY"),
        customTextColor: "white",
        ...rightBoxProps,
      }}
      {...props}
    />
  );
};

export default ServiceLife39Header;


